import { Typography } from "@mui/material";

import {
  faqs,
  howItWorks,
  createPerkTotalLabel,
  purchaseSeatsLanguages,
  redeemGiftCardLanguages,
  purchaseGiftCardLanguages,
  AnalyticsHeader,
  inventoryCardSuiteModal,
  InventoryCard,
  leftFieldPorchSuiteNames,
  LeftFieldPorchContent,
  StudioSuiteContent,
  studioSuiteNames,
  SuitesContent,
  LegendsContent,
  legendSuiteNames,
  legendSuiteFNames,
  threeParkingPassSuiteNames,
  threeOverflowSuiteNames,
  getSuiteAmenityOverride,
} from "./helpers";
import { routes } from "@/global/routes";
import {
  DbacksTCLanguage,
  DbacksHamburgerTCListItems,
  DbacksAdditionalDetailsDisclaimerTC,
} from "../../tc_helper_dbacks";
import { createJsxLink } from "@/global/utils/utils.dom";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";

import type { TeamConfig } from "@/global/hooks/useTeamConfig";

import BackgroundImage from "public/images/diamondbacks/dbacks_bg.jpeg";
import PremiumMenu from "public/images/diamondbacks/D-backs Suite Menu.jpg";
import SeatMap3dPreview from "public/images/diamondbacks/seat_map_preview.png";
import BannerImage from "public/images/diamondbacks/MK05-10251389 Web - 2026 Attend Site Specs-1486x148-SUITES.jpg";

const porchImage1 =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2025%20Suites%20Images/HR%20Porch%201.JPG";
const porchImage2 =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2025%20Suites%20Images/HR%20Porch%202.JPG";
const porchImage3 =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2025%20Suites%20Images/HR%20Porch%203.jpg";
const porchImage4 =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2025%20Suites%20Images/HR%20Porch%204.JPG";
const RFHRPorchMenu =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/RF%20HR%20Porch.png";

// Menu images shown in the "View F&B" slider for the menu-upgrade add-ons
const PremiumBeerWineMenu =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Premium%2B%20Beer%20and%20Wine%20Menu.jpg";
const AllInclusiveBeerWineMenu =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/All-Inclusive%20Beer%20and%20Wine%20Menu.jpg";

const LogoImage = "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png";

const LeftFieldPorchImages = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/20240413_CardinalsvsDbacks_kg192%20(2).jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/DSC_9370-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/DSC_9375-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/DSC_9385-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/LF%20HR%20Porch/LF%20HR%20Porch%20Menu.png",
];

const LegendSuiteImages = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/Legends%20Suites/34-34-DSC08518-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/Legends%20Suites/35-35-DSC08530-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/Legends%20Suites/36-36-DSC08540.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/Legends%20Suites/40-40-DSC08575.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/Legends%20Suites/DSC_9160.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/Legends%20Suites/Legends%20Menu%20.png",
];

const suite10Images = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2010/DSC_8417.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2010/DSC_8447.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2010/DSC_8685-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2010/DSC_9025-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2010/DSC_9035-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/Premium%20Menu%202026%20Screenshot.png",
];

const RandySuiteImages = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/DSC_8417.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/DSC_8447.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/DSC_8690-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/DSC_8710-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Randy%20Suite/Premium%20Menu%202026%20Screenshot.png",
];

const suite19Images = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2019/DSC_8417.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2019/DSC_8447.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2019/DSC_8980-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2019/DSC_8990-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2019/DSC_9015-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Premium%20Menu%202026%20Screenshot.png",
];

const suite20Images = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8417.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8447.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8955-Edit-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8960-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Premium%20Menu%202026%20Screenshot.png",
];

const suite23Images = [
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2023/DSC_8417.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2023/DSC_8447.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2023/DSC_8560-Edit.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2023/DSC_8890.jpg",
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Premium%20Menu%202026%20Screenshot.png",
];

const config: TeamConfig = {
  teamSchema: "dbacks_suites",
  browserTitle: "Arizona Diamondbacks",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  mlbTeamId: 109,
  teamName: "Arizona Diamondbacks",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10167-diamondbacks-sec",
    mapId: "blockmap2d",

    suiteSectionNameMapping: {
      "Studio@122A": ["Studio A"],
      "Studio@122B": ["Studio B"],
      "Legends Suite C": ["Legends C"],
      "Legends Suite D": ["Legends D"],
      "Legends Suite E": ["Legends E"],
      "Legends Suite F": ["Legends F"],
      "WM Open Suite 16": ["Suite 16"],
    },

    isShowAvailableSeatsButtonHidden: true,
    dvmFallback3dViewSectionId: "S_144",

    suiteImages: [
      "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Image%201.jpg",
      "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Image%202.jpg",
      "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Image%203.jpg",
      "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Image%204.jpg",
      PremiumMenu.src,
    ],

    specificSectionImages: {
      PRCHL1: LeftFieldPorchImages,
      PRCHL2: LeftFieldPorchImages,
      PRCHL3: LeftFieldPorchImages,
      PRCHL4: LeftFieldPorchImages,
      PRCHL5: LeftFieldPorchImages,
      PRCHL6: LeftFieldPorchImages,
      PRCHL7: LeftFieldPorchImages,
      PRCHL8: LeftFieldPorchImages,

      PRCHR1: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR2: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR3: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR4: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR5: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR6: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR7: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR8: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],
      PRCHR9: [
        porchImage1,
        porchImage2,
        porchImage3,
        porchImage4,
        RFHRPorchMenu,
      ],

      122: [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Studio%20@122/DSC_9225-Edit.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Studio%20@122/DSC_9230.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Studio%20@122/DSC04331.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Studio%20@122/Studio@122%20Menu.png",
      ],

      S10: suite10Images,
      S1: suite10Images,
      S2: suite10Images,
      S3: suite10Images,
      S4: suite10Images,
      S5: suite10Images,
      S6: suite10Images,
      S7: suite10Images,
      S8: suite10Images,
      S9: suite10Images,
      S11: suite10Images,
      S12: suite10Images,
      S13: suite10Images,
      S14: suite10Images,
      S15: suite10Images,
      S50: suite10Images,
      S51: RandySuiteImages,
      S52: suite10Images,
      S53: suite10Images,
      S55: suite10Images,

      S16: [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2016%20%20%281%29.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/2026%20Suites%20Images/Suite%2016%20Picture.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8417.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/DSC_8447.jpg",
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Premium%20Menu%202026%20Screenshot.png",
      ],
      S17: suite19Images,
      S18: suite19Images,
      S19: suite19Images,
      S20: suite20Images,
      S21: suite19Images,

      S22: suite23Images,
      S23: suite23Images,
      S24: suite23Images,
      S25: suite23Images,
      S28: suite23Images,
      S29: suite23Images,
      S30: suite23Images,
      S31: suite23Images,
      S32: suite23Images,
      S33: suite23Images,
      S34: suite23Images,
      S35: suite23Images,
      S36: suite23Images,
      S37: suite23Images,
      S38: suite23Images,
      S39: suite23Images,
      S40: suite23Images,
      S41: suite23Images,
      S44: suite23Images,
      S45: suite23Images,
      S46: suite23Images,
      S47: suite23Images,
      S48: suite23Images,
      S49: suite23Images,

      TheDraftRoom: LegendSuiteImages,
    },

    specificEventCodeImages: {
      "26DB510": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/SS26-04260517%20Mothers%20Day%20Suite%20Marketing%20Promo_600x800.jpg",
      ],
      "26DB621": [
        "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/AZD%20Suites%20Images/Father%27s%20Day%20Image.jpg",
      ],
    },
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: false,
  inventoryType: inventoryTypeUIDs.suiteLevelV2,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    invPreviewAccountGroup: ["0"],
    isPerksEnabled: true,
    isCheckoutAdditionalDetailsEnabled: true,
    hideViewTicketsInThankYouPage: true,

    allowCheckoutFromPreview: true,
  },

  oktaClientId: "",
  oktaIssuer: "",
  platform: vendorUUIDs.ticketmaster,
  refreshInventoryWhenEventClick: false,

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    AnalyticsHeader: AnalyticsHeader,
  },

  isSaveCardAllowed: true,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl:
      "https://premium.attendevents.com/dbacks_suites/premium",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/azdbacks/my-events",

  // images
  images: {
    findGamesBannerImage: BannerImage.src,
    authBackgroundImage: BackgroundImage.src,
    checkoutStatusPageImage: BackgroundImage.src,
    giftCardStandalonePageImage: BannerImage.src,
    logoImage: LogoImage + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    inventoryContainer: {
      emptyStateTitle: "No D-backs Suites Available.",
      emptyStateDesc: (
        <>
          Try another game or email{" "}
          {createJsxLink("suites@dbacks.com", "mailto:suites@dbacks.com")} for
          suite availability to this game
        </>
      ),
      getGridCellHeight: (arg) => (arg?.mdDown ? 260 : 190),
    },

    inventoryCardSettings: {
      isPBLineItemsVisible: false,
      isParkingPriceVisible: true,
      seatCountLabel: "Tickets Included",

      FBPackageValueByEventCode: {
        "26DS712": "$640 credit",
        "26DS819": "$640 credit",
        "26DS906": "$720 credit",
      },

      suiteLevelInventoryCard: {
        customButtons: [
          {
            id: 1,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <LeftFieldPorchContent />,
              });
            },
            suiteNames: leftFieldPorchSuiteNames,
          },
          {
            id: 2,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <StudioSuiteContent />,
              });
            },
            suiteNames: studioSuiteNames,
          },
          {
            id: 3,
            label: "More Info",
            onClick: (inventory) => {
              // some suites have event-specific amenities (see helpers)
              const override = getSuiteAmenityOverride(inventory);
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <SuitesContent {...override} />,
              });
            },
            // Suites 1 to 57, excluding the 3-parking suites and the new suites with custom amenities
            suiteNames: Array.from(
              { length: 57 },
              (_, i) => `Suite ${i + 1}`
            ).filter(
              (name) =>
                !threeParkingPassSuiteNames.includes(name) &&
                !threeOverflowSuiteNames.includes(name)
            ),
          },
          {
            id: 5,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <SuitesContent parkingPasses={3} />,
              });
            },
            suiteNames: threeParkingPassSuiteNames,
          },
          {
            id: 6,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: (
                  <SuitesContent tickets={18} overflow={3} parkingPasses={4} />
                ),
              });
            },
            suiteNames: threeOverflowSuiteNames,
          },
          {
            id: 4,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <LegendsContent />,
              });
            },
            suiteNames: legendSuiteNames,
          },
          {
            id: 7,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: (
                  <LegendsContent
                    tickets={25}
                    overflow={15}
                    parkingPasses={8}
                  />
                ),
              });
            },
            suiteNames: legendSuiteFNames,
          },
        ],
        renderBody: [
          {
            id: 1,
            component: () => <InventoryCard />,
          },
        ],
      },
    },

    perks: {
      hideAddAllButton: true,
      images: {
        foodUpgrade: [PremiumBeerWineMenu],
        handsHistory: [AllInclusiveBeerWineMenu],
        allInclusiveFnb: [AllInclusiveBeerWineMenu],
      },
      displayOnlyPrice: ["handsHistory", "foodUpgrade"],
      isOpenByDefault: true,
      groupedSections: [
        {
          title: "Upgrade Your Menu",
          description:
            "Enhance your suite experience with the offerings below:",
          perkCodes: ["foodUpgrade", "allInclusiveFnb"],
          singleSelect: true,
        },
      ],
    },
    checkoutPerkSubtotals: {
      perkTotalLabel: createPerkTotalLabel,
    },

    eventCardSettings: {
      noInventoryMessage: "Email suites@dbacks.com for availability.",
      hideSoldOutTag: true,
    },

    checkoutPage: {
      checkoutForm: {
        hideContractTitle: true,
        hideContractLastName: true,
        hideContractFirstName: true,
        hideContractAddress: false,
        sameAsContractSignerDefaultChecked: true,
        optionalAdditionalDetailsContractTitle: true,
        optionalAdditionalDetailsContractLastName: true,
        optionalAdditionalDetailsContractFirstName: true,
      },
    },

    findGames: {
      setEventsWithoutSorting: true,
    },
  },

  colors: {
    primary: "#AA182C",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: <DbacksHamburgerTCListItems />, // can be react node as well
    checkoutTermsAndCondition: <DbacksTCLanguage />,
    registrationTermsAndCondition: <DbacksTCLanguage />,
    additionalDetailsDisclaimerTC: <DbacksAdditionalDetailsDisclaimerTC />,
    purchaseSeats: purchaseSeatsLanguages,
    purchaseGiftCard: purchaseGiftCardLanguages,
    redeemGiftCard: redeemGiftCardLanguages,

    checkoutServiceNote: (
      <Typography variant="body2" color="textSecondary">
        Your reservation is not yet complete until notification from the Arizona
        Diamondbacks confirming your reservation has been accepted in accordance
        with our agreement.
      </Typography>
    ),

    giftCard: {
      title: "Give The Gift Of Broadway",
      createGiftCard: {
        description:
          "Share the magic of Broadway with a friend or loved one. Upon purchase of a gift card, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift card is not refundable.",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Hippodrome Broadway Series shows in Baltimore.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Hippodrome Broadway Series shows in Baltimore.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
        },
        logout: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore.",
        },
        success: {
          description:
            "has been added to your Hippodrome Broadway Series in Baltimore Account Manager account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
